import { OrderType } from '../../../modules/orders/interfaces/orderType.enum';
import { SatisfactionSurveyFrequencyType } from './satisfactionSurveyFrequencyType.enum';

export enum SatisfactionSurveyAudience {
  CUSTOMER = 'customer',
  SALES_REP = 'sales_rep',
  BRAND_ADMIN = 'brand_admin',
}

export interface SatisfactionSurveySettings {
  id: string | null;
  enabled: boolean;
  url: string | null;
  message: string | null;
  orderType: OrderType;
  audiences: SatisfactionSurveyAudience[];
  frequencyType: SatisfactionSurveyFrequencyType;
  frequencyLastDays: number | null;
}

export type UpdateSatisfactionSurveySettings = Partial<Omit<SatisfactionSurveySettings, 'id'>>;
